import { useState } from 'react'

import { BordersStyles, Box, Button } from '@factorialco/deprecated-design-system'
import compact from 'lodash/compact'

import UserSelector from 'modules/core/components/UserSelector'
import createComputed from 'modules/core/hooks/createComputed'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import employees, { Employees } from 'modules/employees/store/collections/employees'

interface Props {
  onEmployeeSelected: (employeeId: number) => void
  onDiscard: () => void
}

const getUsersToDisplay = createComputed((employeesToDisplay: Employees) => {
  const userIds = [...employeesToDisplay.models].map((employee) => employee.attributes.access_id)

  const uniqueUserIds = Array.from(new Set(userIds))

  return compact(uniqueUserIds.map((id) => users.get(id)))
})

const EmployeeAssigner = ({ onEmployeeSelected, onDiscard }: Props) => {
  const usersToDisplay = getUsersToDisplay(employees).get()
  const [selectedIds, setSelectedIds] = useState<number[]>([])

  const border: BordersStyles = {
    bottom: {
      width: 's1',
      style: 'solid',
      color: 'grey400',
    },
  }

  const onSelectUser = (id: number | null | undefined) => {
    if (id) {
      setSelectedIds([id])
    } else {
      setSelectedIds([])
    }
  }

  const onSelect = useUnsafeCallback(
    () => {
      const employeeId = users.find((user) => user.id === selectedIds[0])?.employee?.id

      if (employeeId) {
        onEmployeeSelected(employeeId)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onEmployeeSelected, onSelectUser]
  )

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="spaceBetween"
      cursor="pointer"
      style={{ width: '100%' }}
      border={border}
      paddingX={'s16'}
      paddingTop={'s16'}
      background="grey100"
      paddingBottom={'s0'}
    >
      <UserSelector
        users={usersToDisplay}
        selectedIds={selectedIds}
        autoSort={false}
        onSelect={onSelectUser}
        size="small"
        applyDefaultFilters
      />
      <Box
        alignItems="flexEnd"
        style={{ width: '100%' }}
        background="grey100"
        paddingY="s12"
        gap="s12"
        justifyContent="spaceBetween"
      >
        <Box paddingLeft="s8">
          <Box flexDirection="row" gap="s8">
            <Button type="primary" onClick={onSelect}>
              {i18n.t('split_documents.workflow_payslips.employee_assigner.select_employee')}
            </Button>
            <Button type="secondary" onClick={onDiscard} iconName="delete" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmployeeAssigner
